import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  Typography,
  TextField,
  Button,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import theme from "../../../theme.js";
import { setHeaders } from "../../../redux/slices/authSlice";
import { Buffer } from "buffer";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import { setLogoutUser } from "../../../redux/slices/userSlice.js";

const secretKey = "elm_password_secret_key";
const api = localStorage.getItem("api");
const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    color: "white",
    backgroundColor: "#19433E",
  },
  errorMessage: {
    marginTop: theme.spacing(2),
    color: "red",
    fontWeight: "bold",
  },
  successMessage: {
    marginTop: theme.spacing(2),
    color: "green",
    fontWeight: "bold",
  },
  container: {
    background: "#f9f9f9",
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    width:"95vw",
    maxWidth: theme.spacing(50),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      borderRadius: theme.spacing(1),
    }
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
    textAlign: "center",
    color: "#19433E",
  },
  input: {
    backgroundColor: "#ffffff",
  },
}));

const ChangePasswordCard = () => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordUpdate, setPasswordUpdate] = useState(false);

  const authheaders = useSelector((state) => state.header);
  const dispatch = useDispatch();
  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
    if (newPassword?.length < 7) {
      setNewPassword("");
      toast.error("Password must be atleast 7 characters long!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setConfirmPassword("");
      return;
    }

    try {
      const requestBody = {
        email,
        oldPassword: encryptData(oldPassword),
        newPassword: encryptData(newPassword),
      };

      await axios.put(api + `/user/changepassword`, requestBody, authheaders);

      const cred = `${email}:${newPassword}`;

      const buffer = Buffer.from(cred, "utf-8");
      const base64EncodedString = buffer.toString("base64");
      setPasswordUpdate(true);
      toast.success("Password changed successfully", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });

      setEmail("");
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setTimeout(() => {
        dispatch(setLogoutUser());
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('token')
      }, 30000);
    } catch (error) {
      toast.error("Failed to change password. Check your credentials!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Container maxWidth="sm" className={classes.container}>
          <Typography variant="h5" className={classes.title}>
            Change Password
          </Typography>

          {passwordUpdate ? (
            <Typography className={classes.successMessage}>
              Your password has been updated.
            </Typography>
          ) : (
            <form className={classes.form} onSubmit={handleChangePassword}>
              <TextField
                label="Email"
                variant="outlined"
                type="email"
                size="small"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={classes.input}
              />
              <TextField
                label="Old Password"
                variant="outlined"
                type="password"
                size="small"
                required
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                className={classes.input}
              />
              <TextField
                label="New Password"
                variant="outlined"
                type="password"
                size="small"
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className={classes.input}
              />
              <TextField
                label="Confirm New Password"
                variant="outlined"
                size="small"
                type="password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={classes.input}
              />
              <Button
                style={{ textTransform: "none" }}
                className={classes.button}
                variant="outlined"
                type="submit"
              >
                Change Password
              </Button>
            </form>
          )}
        </Container>
      </ThemeProvider>
    </div>
  );
};

export default ChangePasswordCard;
